import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "../../../common/api/apiShared";
import { IDeleteFrameworkControlTaskDialogProps } from "./DeleteFrameworkControlTaskDialog";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useDeleteFrameworkControlTaskDialogHooks(props: IDeleteFrameworkControlTaskDialogProps) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removeControlTask = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: any) => {
                props.onDeleted();

                snackbar.show(createElement(Trans, { i18nKey: "controlTaskDeleted", values: { name: props.selectedControlTask.taskName } }));
            },
        });
    };

    async function remove() {
        return await deleteHttp<{}>(`/frameworkControls/${props.controlId}/annualwheelactivity/${props.selectedControlTask.annualWheelActivityId}/`);
    }

    return {
        removeControlTask,
        inProgess: removeMutation.isLoading,
    };
}
